<template>
  <div class="column full-height full-width">
    <div class="col row">
      <div
        class="col column max-width-240 full-height"
        v-if="showAgentBar"
      >
        <div class="col-auto bg-light-blue-1">
          <div class="q-mx-sm">
            <AgentInfo />
          </div>

          <div class="q-mx-sm q-mb-xs">
            <AgentActionButtons />
            <AgentRejectionAlert />
          </div>

          <div class="q-mx-sm">
            <NewAttendance />
          </div>
        </div>

        <AttendanceList />
      </div>

      <div class="col full-height padding16">
        <router-view :key="$route.path" />
      </div>
    </div>

    <div class="row full-width">
      <div class="col titleBar">
        <TitleBar />
      </div>
      <div
        class="col"
        v-if="locationSummaryAgent === 'rodape'"
      >
        <FooterBar />
      </div>
    </div>
    <AttendanceOptionCallback />
  </div>
</template>

<script>
import AgentInfo from '@/components/AgentInfo'
import AgentRejectionAlert from '@/components/AgentRejectionAlert'
import AgentActionButtons from '@/components/AgentActionButtons'
import TitleBar from '@/components/TitleBar'
import FooterBar from '@/components/FooterBar'
import AttendanceList from '@/components/AttendanceList'
import NewAttendance from '@/components/NewAttendance'
import AttendanceOptionCallback from '@/components/AttendanceOptionCallback'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    AgentInfo,
    TitleBar,
    FooterBar,
    NewAttendance,
    AttendanceList,
    AgentActionButtons,
    AgentRejectionAlert,
    AttendanceOptionCallback
  },

  mounted () {
    if (!this.isLogged) this.$router.push({ name: 'ROUTE_AUTH' })
    this.register()
  },

  computed: {
    ...mapState({
      showAgentBar: ({ agentModule }) => {
        const isLoading = Boolean(agentModule?.session?.loading)
        const isOnline = ['ONLINE', 'PAUSED', 'DIALING', 'ONTHEPHONE'].includes(agentModule?.session?.agent?.status)
        return isLoading || isOnline
      },
      locationSummaryAgent: (state) => state.settingsModule.locationSummaryAgent
    }),
    ...mapGetters({
      isLogged: 'authModule/isLogged'
    })
  },

  methods: {
    ...mapActions({
      register: 'broadcastChannelModule/register'
    })
  }
}
</script>

<style lang="sass" scoped>
  div.max-width-240
    width: 100%
    max-width: 240px
    border-right: 1px solid #CFD8DC

  .bg-blue
    background: #e3f2fd !important

  .titleBar
    max-width: 240px
    background: #ddd
</style>
